import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Contact.css';
import ContactForm from '../../components/ContactForm';

const Contact = ({ reCaptcha }) => {

  return (
    <div className={s.root}>
      <div className={s.container}>
        <ContactForm reCaptcha={reCaptcha} />
      </div>
    </div>
  );
}

Contact.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(Contact);
